const isPresent = (value) => value !== undefined && value !== null && value !== "";

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const toPrecision = (value, precision = 2) => {
  const numericValue = Number(value);
  const safePrecision = Number.isFinite(Number(precision)) ? Number(precision) : 2;

  return Number.isFinite(numericValue) ? numericValue.toFixed(safePrecision) : "-";
};

const getQualityAttributeValues = (datum) => {
  if (Array.isArray(datum?.qualityAttributeValues)) return datum.qualityAttributeValues;
  if (Array.isArray(datum?.qualityAttributes)) return datum.qualityAttributes;
  return [];
};

const getQualityAttributeId = (entry) =>
  entry?.qualityAttributeId ?? entry?.attributeId ?? entry?.qualityAttribute?.qualityAttributeId;

const getQualityAttributeName = (entry, qualityAttributeNameLookup) =>
  entry?.qualityAttributeName ??
  entry?.attributeName ??
  entry?.name ??
  entry?.qualityAttribute?.qualityAttributeName ??
  entry?.qualityAttribute?.name ??
  qualityAttributeNameLookup.get(String(getQualityAttributeId(entry))) ??
  (isPresent(getQualityAttributeId(entry))
    ? `Quality Attribute ${getQualityAttributeId(entry)}`
    : null);

const getQualityAttributeValue = (entry) =>
  entry?.value ??
  entry?.qualityAttributeValue ??
  entry?.qualityAttributeValueName ??
  entry?.qualityAttribute?.value ??
  entry?.qualityAttribute?.qualityAttributeValueName ??
  entry?.qualityAttribute?.name;

export const buildQualityAttributeNameLookup = (qualityAttributes = []) => {
  const lookup = new Map();

  if (!Array.isArray(qualityAttributes)) return lookup;

  qualityAttributes.forEach((qualityAttribute) => {
    const qualityAttributeId = qualityAttribute?.qualityAttributeId;
    const qualityAttributeName =
      qualityAttribute?.qualityAttributeName ?? qualityAttribute?.name;

    if (isPresent(qualityAttributeId) && isPresent(qualityAttributeName)) {
      lookup.set(String(qualityAttributeId), qualityAttributeName);
    }
  });

  return lookup;
};

export const getQualityAttributeTooltipLines = (
  datum,
  qualityAttributeNameLookup = new Map()
) =>
  getQualityAttributeValues(datum)
    .map((entry) => ({
      name: getQualityAttributeName(entry, qualityAttributeNameLookup),
      value: getQualityAttributeValue(entry),
    }))
    .filter((entry) => isPresent(entry.name) && isPresent(entry.value))
    .map(
      (entry) =>
        `${escapeHtml(entry.name)}: <strong>${escapeHtml(entry.value)}</strong>`
    );

export const formatReportedPriceTooltip = (
  datum,
  currencySymbol,
  pricePrecision,
  qualityAttributeNameLookup = new Map()
) => {
  const qualityLines = getQualityAttributeTooltipLines(
    datum,
    qualityAttributeNameLookup
  );

  const priceLine = `Reported Price: <strong>${escapeHtml(
    currencySymbol ?? "$"
  )}${toPrecision(datum?.price, pricePrecision)}</strong>`;

  return [...qualityLines, priceLine].join("<br/>");
};
